var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "First-Cashier",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AD03-EMAIL-Dark",
    transform: "translate(-24 -222)",
    fill: "#212121",
    stroke: "#DDD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 245.5a1.5 1.5 0 001.5-1.5v-20a1.5 1.5 0 00-1.5-1.5H26a1.5 1.5 0 00-1.5 1.5v20a1.5 1.5 0 001.5 1.5h20z",
    id: "checkbox"
  })))));
}
SvgCheckbox.displayName = 'Checkbox';
export default SvgCheckbox;